// assets/alpine-store.js

document.addEventListener('alpine:init', () => {
    Alpine.store('global', {
        menuOpen: false, 
        searchOpen: false, 
        basketOpen: false, 
        authOpen: false, 
        atTop: true,
        bagBump: false, // Animasyon tetikleyici

        cartData: { item_count: 0, items: [] },
        updatingItemKey: null,
        isRemovingLastItem: false, // YENİ: Son eleman silinirken sağ tarafı anında gizlemek için

        notifications: [],

        init() {
            this.fetchCart();
        },

        async fetchCart() {
            try {
                const response = await fetch('/cart.js');
                this.cartData = await response.json();
            } catch (error) {
                console.error('Cart fetch error:', error);
            }
        },
        
        // Şablonun (bag-drawer) beklediği isimler
        get bag() { return this.cartData.items || []; },
        get bagCount() { return this.cartData.item_count || 0; },

        async addToBag(payload) { 
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{ id: payload.id, quantity: payload.quantity || 1 }]
                    })
                });
                
                if (response.ok) {
                    await this.fetchCart();
                    
                    // Nabız animasyonunu tetikle
                    this.bagBump = true;
                    setTimeout(() => { this.bagBump = false; }, 300);

                    // TOAST (BİLDİRİM) OLUŞTURMA
                    this.notifications.push({
                        id: Date.now(),
                        message: payload.title || 'Item'
                    });
                    
                    // 4 saniye sonra sadece bu bildirimi diziden sil
                    setTimeout(() => { 
                        this.notifications = this.notifications.filter(n => n.id !== notifId);
                    }, 4000);
                }
            } catch (error) {
                console.error('Add to bag error:', error);
            }
        },

        async changeQuantity(lineKey, quantity) {
            this.updatingItemKey = String(lineKey);
            
            // EĞER: Adet 0'a çekiliyorsa VE sepette tek ürün varsa, bayrağı kaldır
            if (quantity === 0 && this.cartData.item_count === 1) {
                this.isRemovingLastItem = true;
            }

            try {
                const apiRequest = fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: lineKey, quantity: quantity })
                });

                const minimumDelay = new Promise(resolve => setTimeout(resolve, 400));
                const [response] = await Promise.all([apiRequest, minimumDelay]);
                
                if (response.ok) {
                    await this.fetchCart();
                }
            } catch (error) {
                console.error('Change quantity error:', error);
            } finally {
                this.updatingItemKey = null;
                this.isRemovingLastItem = false; // İşlem bitince bayrağı sıfırla
            }
        },
    });
});